<template>
  <a-modal :title="viewTitle" visible @cancel="cancel">
    <ak-inputs :options="editFields" ref="inputs" v-model="record" />
    <template slot="footer">
      <a-button @click="cancel">取消</a-button>
      <a-button type="primary" @click="cancel">确定</a-button>
    </template>
  </a-modal>
</template>

<script>

import store from '@/store'
export default {
  name: 'viewPage',
  data () {
    return {
      orderView: false
    }
  },
  mounted () {
    console.log(this.record)
  },
  computed: {
    editFields () {
      let data = []
      if ((this.model.className === 'Order' || this.model.className === 'verifyOrder') && (store.state.user && Object.keys(store.state.user).indexOf('correlatedUser') !== -1 && store.state.user.correlatedUser.length)) {
        data = this.model.fields.filter(field => !field.hideOnEdit && field.name !== 'costPrice')
      } else {
        data = this.model.fields.filter(field => !field.hideOnEdit)
      }
      let arr = []
      data.forEach((e) => {
        let obj = {}
        if (e.disabled) {
          obj = { ...e.schema, name: e.name, disabled: true }
        } else {
          obj = { ...e.schema, name: e.name, disabled: true }
        }
        arr.push(obj)
      })
      return arr
    }
  },
  methods: {
    cancel () {
      this.$emit('complete', 'cancel')
    }
  },
  props: {
    record: Object, // 当前行的数据
    model: Object, // 当前model对象
    field: Object, // 当前field对象
    viewTitle: {
      type: String,
      default: '查看'
    }
  }
}
</script>

<style scoped>

</style>
